import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/maintenance_dob/ticketsReportActions'
import * as api from '../../../api/reports/maintenance_dob/ticketsReport'

function* ticketsReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.TICKETS_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TICKETS_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* ticketsReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({
      type: constants.TICKETS_REPORT_GET_ORGANIZATION_LIST.SUCCESS,
      payload
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TICKETS_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* ticketsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.TICKETS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TICKETS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchticketsReportGetJobList() {
  yield takeLatest(constants.TICKETS_REPORT_GET_JOB_LIST.ACTION, ticketsReportGetJobList)
}

function* watchticketsReportGetOrganizationList() {
  yield takeLatest(
    constants.TICKETS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    ticketsReportGetOrganizationList
  )
}

function* watchticketsReportGetFullReport() {
  yield takeLatest(constants.TICKETS_REPORT_GET_FULL_REPORT.ACTION, ticketsReportGetFullReport)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchticketsReportGetOrganizationList),
    fork(watchticketsReportGetFullReport),
    fork(watchticketsReportGetJobList)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/maintenance_dob/ticketsReportSaga.js